module.exports = __webpack_public_path__ + "img/familymoments.aacb3ddb.jpg";